// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__H0HPD","face":"logo_face__LQ3I8","layer":"logo_layer__Og4BF"};